import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import BookingComplete from '../BookingComplete';
import BookingError from '../BookingError';
import BookingTerms from '../BookingTerms';
import BookingHelp from '../BookingHelp';
import withLocalized from '../../localization/withLocalized';

import {
  ModalContainer,
  ModalHeader,
  MenuButton,
  ContentContainer,
  TRANSITION_DURATION,
} from '../../common/components/modal/ui/index';

import Icon from '../../common/components/icon/Icon';
import { ICONS } from '../../common/components/icon/Icons';

const SPage = (props) => {
  const { match, localized } = props;
  const { subpage } = match.params;
  let title = '';
  let Component;
  let canGoBack = true;
  switch(subpage) {
    case 'help' :
      title = localized('booking.help.modal_title');
      Component = BookingHelp;
      break;
    case 'terms' :
      title = localized('booking.terms.modal_title');
      Component = BookingTerms;
      break;
    case 'complete' :
      title = localized('booking.complete.modal_title');
      Component = BookingComplete;
      canGoBack = false;
      break;
    case 'error' :
      title = localized('booking.error.modal_title');
      Component = BookingError;
      canGoBack = false;
      break;
    default:
      break;
  }
  // const title = subpage === 'help' ? 'Apua' : 'Tilausehdot';
  // const Component = subpage === 'help' ? BookingHelp : BookingTerms;
  return (
    <ModalContainer zIndex={2}>
      <ModalHeader>
        <MenuButton onClick={canGoBack ? props.onBackClick : undefined}>
          {canGoBack && (
            <Icon
              icon={ICONS.ARROW_LEFT}
            />
          )}
        </MenuButton>
        <h2>{title}</h2>
      </ModalHeader>
      <ContentContainer>
        <Component linkRoot={props.linkRoot} />
      </ContentContainer>
    </ModalContainer>
  );
};

const SubPage = withLocalized(SPage);

class SubPageContainer extends Component {
  action = 'push';
  backLink = null;

  componentWillUpdate(nextProps) {
    if (!nextProps.match.params.subpage) {
      this.action = 'pop';
    } else if (!this.props.match.params.subpage) {
      this.action = 'push';
    } else {
      this.action = (nextProps.history.action).toLowerCase();
    }
    if(nextProps.match.params.subpage) {
      this.backLink = this.props.match.url;
    } else {
      this.backLink = null;
    }
  }

  render() {
    const { match } = this.props;
    const key = match.params.subpage || 'root';
    const transitionName = 'slide-' + this.action;
    const baseRoot = match.url.split(`/book`)[0];
    const linkRoot = match.url.split(`/${match.params.subpage}`)[0];
    const onBackClick = () => {
      if(this.backLink) {
        this.props.history.goBack();
      } else {
        this.props.history.replace(`${linkRoot}`)
      }
    };
    const onCloseClick = () => {
      const { location } = this.props;
      const isEmbed = location.pathname.match(/^\/embed\/(.*)/);
      if (isEmbed) {
        try {
          if(window.parent && window.self !== window.top) {
            window.parent.window.postMessage("BTClose", "*");
          } else {
            window.close();
          }
        } catch(e) {};
      } else {
        this.props.onCloseLink ? this.props.history.replace(this.props.onCloseLink) : this.props.history.replace(`${baseRoot}`);
      }
    };

    return (
      <ReactCSSTransitionGroup
        component='div'
        transitionName={transitionName}
        transitionEnterTimeout={TRANSITION_DURATION}
        transitionLeaveTimeout={TRANSITION_DURATION}
      >
        {key === 'root'
          ? null
          : <SubPage
            {...this.props}
            key={key}
            linkRoot={linkRoot}
            match={match}
            onBackClick={onBackClick}
            onCloseClick={onCloseClick}
          />
        }
      </ReactCSSTransitionGroup>
    )
  }
}


export {
  SubPage,
  SubPageContainer
}



// WEBPACK FOOTER //
// ./src/modules/booking/components/BookingSubPage.js